import MobileCarousel from '../../src/js/mobile-carousel';

export default class PlatformAdvantages {
  constructor() {
    const $els = document.querySelectorAll('.js-platform-advantages-carousel');
    $els.forEach($el => new MobileCarousel($el));
  }
}
